export function loadFontweightPlugin() {
  FroalaEditor.PLUGINS.fontweight = function (editor) {
    function applyFontWeight(val) {
      if (val === 'inherit') {
        editor.format.removeStyle('font-weight');
      } else {
        editor.format.applyStyle('font-weight', val);
      }
    }

    function getCurrentWeight() {
      const el = editor.selection.element();
      return el && el.style ? el.style.fontWeight : null;
    }

    function _init() {}

    return {
      _init,
      applyFontWeight,
      getCurrentWeight
    };
  };

  // Define the icon
  FroalaEditor.DefineIcon('fontweight', { NAME: 'bold', SVG_KEY: 'bold' });

  // Register the command with dropdown
  FroalaEditor.RegisterCommand('fontweight', {
    title: 'Font Weight',
    type: 'dropdown',
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    options: {
      'inherit': 'Default',
      '300': '300',
      '400': '400',
      '600': '600',
      '700': '700'
    },
    callback: function (cmd, val) {
      this.fontweight.applyFontWeight(val);
    },
    refreshOnShow: function ($btn, $dropdown) {
      const current = this.fontweight.getCurrentWeight() || 'inherit';
      $dropdown.find('a').removeClass('fr-active');
      $dropdown.find(`a[data-param1="${current}"]`).addClass('fr-active');
    }
  });

  FroalaEditor.LANGUAGE['de'] = FroalaEditor.LANGUAGE['de'] || {};

  // Extend it with your plugin's translations
  Object.assign(FroalaEditor.LANGUAGE['de'].translation, {
    'Font Weight': 'Schriftgewicht',
  });
}
